import {
  Australia,
  Austria,
  Bahrain,
  Belarus,
  Belgium,
  Bulgaria,
  Canada,
  CzechRepublic,
  Denmark,
  Estonia,
  Finland,
  France,
  Georgia,
  Germany,
  HongKong,
  Ireland,
  Israel,
  Italy,
  Kazakhstan,
  Latvia,
  Liechtenstein,
  Lithuania,
  Luxembourg,
  Netherlands,
  Norway,
  Poland,
  Russia,
  SaudiArabia,
  Slovakia,
  Spain,
  Sweden,
  Switzerland,
  UAE,
  UK,
  Ukraine,
  USA,
} from '../../assets/icons-components';

// country machine values
export const AUSTRALIA = 'AUSTRALIA';
export const AUSTRIA = 'AUSTRIA';
export const BAHRAIN = 'BAHRAIN';
export const BELARUS = 'BELARUS';
export const BELGIUM = 'BELGIUM';
export const BOLGARY = 'BOLGARY';
export const CANADA = 'CANADA';
export const CZECH = 'CZECH';
export const DENMARK = 'DENMARK';
export const ESTONIA = 'ESTONIA';
export const FINLAND = 'FINLAND';
export const FRANCE = 'FRANCE';
export const GEORGIA = 'GEORGIA';
export const GERMANY = 'GERMANY';
export const HONG_KONG = 'HONG_KONG';
export const IRELAND = 'IRELAND';
export const ISRAEL = 'ISRAEL';
export const ITALY = 'ITALY';
export const KAZAKHSTAN = 'KAZAKHSTAN';
export const LATVIA = 'LATVIA';
export const LICHTENSTEIN = 'LICHTENSTEIN';
export const LITHUANIA = 'LITHUANIA';
export const LUXEMBOURG = 'LUXEMBOURG';
export const NETHERLANDS = 'NETHERLANDS';
export const NORWAY = 'NORWAY';
export const POLAND = 'POLAND';
export const RUSSIA = 'RUSSIA';
export const SAUDI_ARABIA = 'SAUDI_ARABIA';
export const SLOVAKIA = 'SLOVAKIA';
export const SPAIN = 'SPAIN';
export const SWEDEN = 'SWEDEN';
export const SWITZERLAND = 'SWITZERLAND';
export const UKRAINE = 'UKRAINE';
export const UNITED_ARAB_EMIRATES = 'UNITED_ARAB_EMIRATES';
export const UNITED_KINGDOM = 'UNITED_KINGDOM';
export const USA_NAME = 'USA';

// country iso codes
export const AUSTRALIA_ISO = 'AU';
export const AUSTRIA_ISO = 'AT';
export const BAHRAIN_ISO = 'BH';
export const BELARUS_ISO = 'BY';
export const BELGIUM_ISO = 'BE';
export const BOLGARY_ISO = 'BG';
export const CANADA_ISO = 'CA';
export const CZECH_ISO = 'CZ';
export const DENMARK_ISO = 'DK';
export const ESTONIA_ISO = 'EE';
export const FINLAND_ISO = 'FI';
export const FRANCE_ISO = 'FR';
export const GEORGIA_ISO = 'GE';
export const GERMANY_ISO = 'DE';
export const HONG_KONG_ISO = 'HK';
export const IRELAND_ISO = 'IE';
export const ISRAEL_ISO = 'IL';
export const ITALY_ISO = 'IT';
export const KAZAKHSTAN_ISO = 'KZ';
export const LATVIA_ISO = 'LV';
export const LICHTENSTEIN_ISO = 'LI';
export const LITHUANIA_ISO = 'LT';
export const LUXEMBOURG_ISO = 'LU';
export const NETHERLANDS_ISO = 'NL';
export const NORWAY_ISO = 'NO';
export const POLAND_ISO = 'PL';
export const RUSSIA_ISO = 'RU';
export const SAUDI_ARABIA_ISO = 'SA';
export const SLOVAKIA_ISO = 'SK';
export const SPAIN_ISO = 'ES';
export const SWEDEN_ISO = 'SE';
export const SWITZERLAND_ISO = 'CH';
export const UKRAINE_ISO = 'UA';
export const UNITED_ARAB_EMIRATES_ISO = 'AE';
export const UNITED_KINGDOM_ISO = 'GB';
export const USA_ISO = 'US';

export const countryMachineValueToIsoCodeMapper = {
  [AUSTRALIA]: AUSTRALIA_ISO,
  [AUSTRIA]: AUSTRIA_ISO,
  [BAHRAIN]: BAHRAIN_ISO,
  [BELARUS]: BELARUS_ISO,
  [BELGIUM]: BELGIUM_ISO,
  [BOLGARY]: BOLGARY_ISO,
  [CANADA]: CANADA_ISO,
  [CZECH]: CZECH_ISO,
  [DENMARK]: DENMARK_ISO,
  [ESTONIA]: ESTONIA_ISO,
  [FINLAND]: FINLAND_ISO,
  [FRANCE]: FRANCE_ISO,
  [GEORGIA]: GEORGIA_ISO,
  [GERMANY]: GERMANY_ISO,
  [HONG_KONG]: HONG_KONG_ISO,
  [IRELAND]: IRELAND_ISO,
  [ISRAEL]: ISRAEL_ISO,
  [ITALY]: ITALY_ISO,
  [KAZAKHSTAN]: KAZAKHSTAN_ISO,
  [LATVIA]: LATVIA_ISO,
  [LICHTENSTEIN]: LICHTENSTEIN_ISO,
  [LITHUANIA]: LITHUANIA_ISO,
  [LUXEMBOURG]: LUXEMBOURG_ISO,
  [NETHERLANDS]: NETHERLANDS_ISO,
  [NORWAY]: NORWAY_ISO,
  [POLAND]: POLAND_ISO,
  [RUSSIA]: RUSSIA_ISO,
  [SAUDI_ARABIA]: SAUDI_ARABIA_ISO,
  [SLOVAKIA]: SLOVAKIA_ISO,
  [SPAIN]: SPAIN_ISO,
  [SWEDEN]: SWEDEN_ISO,
  [SWITZERLAND]: SWITZERLAND_ISO,
  [UKRAINE]: UKRAINE_ISO,
  [UNITED_ARAB_EMIRATES]: UNITED_ARAB_EMIRATES_ISO,
  [UNITED_KINGDOM]: UNITED_KINGDOM_ISO,
  [USA_NAME]: USA_ISO,
};

export const countryIsoCodeToFlagIconMapper = {
  [AUSTRALIA_ISO]: Australia,
  [AUSTRIA_ISO]: Austria,
  [BAHRAIN_ISO]: Bahrain,
  [BELARUS_ISO]: Belarus,
  [BELGIUM_ISO]: Belgium,
  [BOLGARY_ISO]: Bulgaria,
  [CANADA_ISO]: Canada,
  [CZECH_ISO]: CzechRepublic,
  [DENMARK_ISO]: Denmark,
  [ESTONIA_ISO]: Estonia,
  [FINLAND_ISO]: Finland,
  [FRANCE_ISO]: France,
  [GEORGIA_ISO]: Georgia,
  [GERMANY_ISO]: Germany,
  [HONG_KONG_ISO]: HongKong,
  [IRELAND_ISO]: Ireland,
  [ISRAEL_ISO]: Israel,
  [ITALY_ISO]: Italy,
  [KAZAKHSTAN_ISO]: Kazakhstan,
  [LATVIA_ISO]: Latvia,
  [LICHTENSTEIN_ISO]: Liechtenstein,
  [LITHUANIA_ISO]: Lithuania,
  [LUXEMBOURG_ISO]: Luxembourg,
  [NETHERLANDS_ISO]: Netherlands,
  [NORWAY_ISO]: Norway,
  [POLAND_ISO]: Poland,
  [RUSSIA_ISO]: Russia,
  [SAUDI_ARABIA_ISO]: SaudiArabia,
  [SLOVAKIA_ISO]: Slovakia,
  [SPAIN_ISO]: Spain,
  [SWEDEN_ISO]: Sweden,
  [SWITZERLAND_ISO]: Switzerland,
  [UKRAINE_ISO]: Ukraine,
  [UNITED_ARAB_EMIRATES_ISO]: UAE,
  [UNITED_KINGDOM_ISO]: UK,
  [USA_ISO]: USA,
};
